/*
 * レスポンシブ対応メソッド集
 */

const ua = require('../common/useragent');

(function ($) {
  $.fn.extend({
    responsiveHelperSet(options) {
      const o = $.extend(
        {
          tel: true,
          table: true,
          telClass: 'telLink',
          tableClass: 'js-tableWrap01',
        },
        options,
      );
      return this.each(() => {
        // テーブルの横スクロール対応
        if (o.table) {
          $(`.${o.tableClass}`).each(function () {
            $(this).wrap(`<div class="${o.tableClass}"></div>`);
          });
        }

        // スマホ・タブレット電話発信用のリンクを設定
        if (ua.sd && o.tel) {
          $(`.${o.telClass}`).each(function () {
            $(this).wrapInner(
              `<a href="tel:${$(this)
                .text()
                .replace(/-|\(|\)/g, '')}"></a>`,
            );
          });
        }
      });
    },
  });
})(jQuery);
